<fc-outlined-select
  [required]="required"
  [label]="label"
  [control]="control"
  [searchFn]="searchSegments"
></fc-outlined-select>
